// $(function(){
//     //slider block

//     let slider = new Swiper(".js-slider", {
//             slidesPerView: 1,
//             // spaceBetween: 24,
//             // slidesPerGroup: 4,
//             // loop: true,
//             prevButton: ".slider__button_prev",
//             nextButton: ".slider__button_next",
//             // pagination: ".slider__pagination",
//             // paginationClickable: true,
//             centeredSlides: true,
//             // autoplay: 4000,
//             // observer: true,
//             // preloadImages: false,
//             // lazyLoading: true,
//             // watchSlidesVisibility: true,
//             // lazyLoadingInPrevNext: true,
//             // lazyLoadingInPrevNextAmount: 1,
//             // breakpoints: {
//             //     1199: {
//             //         spaceBetween: 16
//             //     },
//             //     1023: {
//             //         slidesPerView: 3
//             //     },
//             //     767: {
//             //         slidesPerView: 2
//             //     },
//             //     480: {
//             //         slidesPerView: 1
//             //     }
//             // }
//         });


// });


// WEBPACK FOOTER //
// ./common.blocks/slider/slider.js